import React from 'react';

interface IProps {
  trades: any;
  base: string;
  flipped: boolean;
  quote: string;
}

const useTradesTableData = ({ trades, base, flipped, quote }: IProps) => {
  // table memoized required fields
  const data = React.useMemo(() => trades, [trades]);
  const columns = React.useMemo(
    () => [
      {
        id: 'formatDate',
        Header: 'Date',
        accessor: 'format_date',
      },
      {
        id: 'priceAUsd',
        Header: 'Price USD',
        accessor: 'price_a_usd',
      },
      {
        id: 'priceA',
        Header: `(${quote})`,
        accessor: 'price_a',
      },
      {
        id: flipped ? 'amount1' : 'amount0',
        Header: `Amount ${base}`,
        accessor: flipped ? 'amount1' : 'amount0',
      },
      {
        id: flipped ? 'amount0' : 'amount1',
        Header: `Total ${quote}`,
        accessor: flipped ? 'amount0' : 'amount1',
      },
      {
        id: 'valueUsd',
        Header: 'Txn Value (USD)',
        accessor: 'value_usd',
      },
      {
        id: 'tx',
        Header: 'Txn Hash',
        accessor: 'tx',
        disableSortBy: true,
        attach_right: true,
      },
    ],
    []
  );

  return { columns, data };
};

export { useTradesTableData };
